import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-12d1d018")

_pushScopeId("data-v-12d1d018")
const _hoisted_1 = { class: "flex flex--width flex--v flex--valign-c flex--gap-50" }
const _hoisted_2 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_3 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
const _hoisted_4 = { class: "flex flex--width flex--v flex--gap-30" }
const _hoisted_5 = { class: "flex flex--width flex--v" }
const _hoisted_6 = {
  for: "name",
  class: "form-label"
}
const _hoisted_7 = {
  id: "nameHelp",
  class: "form-text"
}
const _hoisted_8 = { class: "flex flex--width flex--v" }
const _hoisted_9 = {
  for: "organizer_name",
  class: "form-label"
}
const _hoisted_10 = {
  id: "organizerHelp",
  class: "form-text"
}
const _hoisted_11 = { class: "flex flex--width flex--v" }
const _hoisted_12 = {
  for: "event_type_id",
  class: "form-label"
}
const _hoisted_13 = {
  value: "",
  disabled: ""
}
const _hoisted_14 = {
  id: "eventTypeHelp",
  class: "form-text"
}
const _hoisted_15 = { class: "row mb-3" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = {
  for: "starting_at",
  class: "form-label"
}
const _hoisted_18 = {
  id: "startingAtHelp",
  class: "form-text"
}
const _hoisted_19 = { class: "col-lg-6" }
const _hoisted_20 = {
  for: "ending_at",
  class: "form-label"
}
const _hoisted_21 = {
  id: "endingAtHelp",
  class: "form-text"
}
const _hoisted_22 = { class: "flex flex--width flex--v" }
const _hoisted_23 = {
  for: "description",
  class: "form-label"
}
const _hoisted_24 = {
  id: "descriptionHelp",
  class: "form-text"
}
const _hoisted_25 = { class: "bottom-buttons flex flex--v flex--halign-c flex--valign-c flex--gap-20" }
const _hoisted_26 = {
  class: "btn-group",
  role: "group",
  "aria-label": "button group"
}
const _hoisted_27 = {
  class: "btn-group-vertical",
  role: "group",
  "aria-label": "Vertical button group"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_Plane = _resolveComponent("Plane")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('event.button_submit', _ctx.create ? 2 : 1),
        disabled: _ctx.processing || _ctx.submitDisabled,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submit(false)))
      }, null, 8, ["title", "disabled"]),
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('event.button_submit_and_continue', _ctx.create ? 2 : 1),
        disabled: _ctx.processing || _ctx.submitDisabled,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.submit(true)))
      }, null, 8, ["title", "disabled"]),
      (!_ctx.create)
        ? (_openBlock(), _createBlock(_component_GenericButton, {
            key: 0,
            class: "btn-group-button",
            title: _ctx.$transChoice('event.button_submit', 3),
            secondary: true,
            disabled: _ctx.processing || _ctx.submitDisabled,
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.submit(false, true)))
          }, null, 8, ["title", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('event.button_submit', _ctx.create ? 2 : 1),
        disabled: _ctx.processing || _ctx.submitDisabled,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submit(false)))
      }, null, 8, ["title", "disabled"]),
      _createVNode(_component_GenericButton, {
        class: "btn-group-button",
        title: _ctx.$transChoice('event.button_submit_and_continue', _ctx.create ? 2 : 1),
        disabled: _ctx.processing || _ctx.submitDisabled,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit(true)))
      }, null, 8, ["title", "disabled"]),
      (!_ctx.create)
        ? (_openBlock(), _createBlock(_component_GenericButton, {
            key: 0,
            class: "btn-group-button",
            title: _ctx.$transChoice('event.button_submit', 3),
            secondary: true,
            disabled: _ctx.processing || _ctx.submitDisabled,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.submit(false, true)))
          }, null, 8, ["title", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Plane, {
      darker: true,
      rounded: true
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$trans("event.name") + "*"), 1),
            _withDirectives(_createVNode("input", {
              id: "name",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formEvent.name = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "nameHelp"
            }, null, 512), [
              [_vModelText, _ctx.formEvent.name]
            ]),
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$trans("event.name_help")), 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$trans("event.organizer") + "*"), 1),
            _withDirectives(_createVNode("input", {
              id: "organizer_name",
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formEvent.organizer_name = $event)),
              type: "text",
              class: "form-control",
              "aria-describedby": "organizerHelp"
            }, null, 512), [
              [_vModelText, _ctx.formEvent.organizer_name]
            ]),
            _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$trans("event.organizer_help")), 1)
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$trans("event.event_type") + "*"), 1),
            _withDirectives(_createVNode("select", {
              id: "event_type_id",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formEvent.event_type_id = $event)),
              class: "form-select",
              "aria-describedby": "eventTypeHelp"
            }, [
              _createVNode("option", _hoisted_13, _toDisplayString(_ctx.$trans("event.event_type_placeholder")), 1),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventTypes, (type) => {
                return (_openBlock(), _createBlock("option", {
                  key: type.id,
                  value: type.id
                }, _toDisplayString(_ctx.$trans("event.type_" + type.name)), 9, ["value"]))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.formEvent.event_type_id]
            ]),
            _createVNode("div", _hoisted_14, _toDisplayString(_ctx.$trans("event.event_type_help")), 1)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$trans("event.starting_at") + "*"), 1),
              _withDirectives(_createVNode("input", {
                id: "starting_at",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formEvent.starting_at = $event)),
                type: "date",
                class: "form-control",
                "aria-describedby": "startingAtHelp"
              }, null, 512), [
                [_vModelText, _ctx.formEvent.starting_at]
              ]),
              _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$trans("event.starting_at_help")), 1)
            ]),
            _createVNode("div", _hoisted_19, [
              _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$trans("event.ending_at") + "*"), 1),
              _withDirectives(_createVNode("input", {
                id: "ending_at",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formEvent.ending_at = $event)),
                type: "date",
                class: "form-control",
                "aria-describedby": "endingAtHelp"
              }, null, 512), [
                [_vModelText, _ctx.formEvent.ending_at]
              ]),
              _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$trans("event.ending_at_help")), 1)
            ])
          ]),
          _createVNode("div", _hoisted_22, [
            _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$trans("event.description")), 1),
            _withDirectives(_createVNode("textarea", {
              id: "description",
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formEvent.description = $event)),
              class: "form-control",
              rows: "5",
              "aria-describedby": "organizerHelp"
            }, null, 512), [
              [_vModelText, _ctx.formEvent.description]
            ]),
            _createVNode("div", _hoisted_24, _toDisplayString(_ctx.$trans("event.description_help")), 1)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_25, [
      _createVNode("div", _hoisted_26, [
        _createVNode(_component_GenericButton, {
          class: "btn-group-button",
          title: _ctx.$transChoice('event.button_submit', _ctx.create ? 2 : 1),
          disabled: _ctx.processing || _ctx.submitDisabled,
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.submit(false)))
        }, null, 8, ["title", "disabled"]),
        _createVNode(_component_GenericButton, {
          class: "btn-group-button",
          title: _ctx.$transChoice('event.button_submit_and_continue', _ctx.create ? 2 : 1),
          disabled: _ctx.processing || _ctx.submitDisabled,
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.submit(true)))
        }, null, 8, ["title", "disabled"]),
        (!_ctx.create)
          ? (_openBlock(), _createBlock(_component_GenericButton, {
              key: 0,
              class: "btn-group-button",
              title: _ctx.$transChoice('event.button_submit', 3),
              secondary: true,
              disabled: _ctx.processing || _ctx.submitDisabled,
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.submit(false, true)))
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_27, [
        _createVNode(_component_GenericButton, {
          class: "btn-group-button",
          title: _ctx.$transChoice('event.button_submit', _ctx.create ? 2 : 1),
          disabled: _ctx.processing || _ctx.submitDisabled,
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.submit(false)))
        }, null, 8, ["title", "disabled"]),
        _createVNode(_component_GenericButton, {
          class: "btn-group-button",
          title: _ctx.$transChoice('event.button_submit_and_continue', _ctx.create ? 2 : 1),
          disabled: _ctx.processing || _ctx.submitDisabled,
          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.submit(true)))
        }, null, 8, ["title", "disabled"]),
        (!_ctx.create)
          ? (_openBlock(), _createBlock(_component_GenericButton, {
              key: 0,
              class: "btn-group-button",
              title: _ctx.$transChoice('event.button_submit', 3),
              secondary: true,
              disabled: _ctx.processing || _ctx.submitDisabled,
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.submit(false, true)))
            }, null, 8, ["title", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_GenericButton, {
        class: "bottom-button",
        title: _ctx.$transChoice('event.button_cancel', _ctx.create ? 2 : 1),
        danger: true,
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.clickInertiaLink('school.dashboard')))
      }, null, 8, ["title"])
    ])
  ]))
})